module.exports = __webpack_public_path__ + "img/che.9c26f60a.svg";